import React from 'react';
import { components } from 'react-select';

const labelStyle = (isFocused: boolean): React.CSSProperties => ({
  position: 'absolute',
  left: 15,
  top: -5,
  zIndex: 1,
  pointerEvents: 'none',
  padding: '0 2px',
  fontSize: 14,
  color: '#ffffff',
});

const Control = ({ children, ...props }: any) => {
  return (
    <>
      <div className="label-header" style={labelStyle(props.isFocused)}>
        {props.selectProps.dropdownLabel}
      </div>
      <components.Control {...props}>{children}</components.Control>
    </>
  );
};

export default Control;
